import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { MdEdit, MdVisibility } from "react-icons/md";
import telerServices from "../../Services/telrService";
import moment from "moment";
import { Link } from "react-router-dom";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
let currentPage1 = 1;

export const TelrPaymentList = () => {
  const history = useHistory();
  const [dataList, setDataList] = useState([]);
  const [Active, setActive] = useState(false);
  const [loader, setLoader] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);

  useEffect(() => {
    let param = {};
    param = { page: currentPage, limit: pagination.limit };
    telerServices.getOnlinePaymentList(param).then((result) => {
      if (result.status === true) {
        setDataList(result.data);
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);
      } else {
        setLoader(false);
      }
    });
  }, [currentPage]);

  const searchPayment = (text) => {
    let searchString = { search: text };
    telerServices.getOnlinePaymentList(searchString).then((result) => {
      if (result.status === true) {
        setDataList(result.data);
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div>
                <input
                  type="text"
                  className={"form-control"}
                  placeholder="Search..."
                  onKeyUp={(e) => searchPayment(e.target.value)}
                />
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th> Quote No.</th>
                    <th> Job No.</th>
                    <th> Customer Name</th>
                    <th>Amount Status</th>
                    <th>Date</th>
                    <th> Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dataList.map((item, index) => {
                    let date = Date(
                      item?.initial_payment_details?.payment_response?.order
                        ?.transaction.date
                    );
                    // console.log("`telr-payment-details?id=${item._id}` ....", `telr-payment-details?id=${item._id}`)
                    return (
                      <tr key={index}>
                        {/* <td scope="row">{index + 1}</td> */}
                        <td className="text-body fw-bold">
                          {(currentPage - 1) * pagination.limit +
                            (index + 1)}
                        </td>

                        <td>{item.quote_token}</td>
                        <td>
                          {
                            /* item.job_details.map((job) => (job.job_token))*/
                            item.job_details.job_token
                          }
                        </td>
                        <td>
                          {
                            item.job_details.customer_details.name
                            /* item.job_details.map((customer) => (customer.customer_details.name))*/
                          }
                        </td>
                        <td>
                          {
                            item.job_details.payment_information?.payment_status
                              ? item.job_details.payment_information
                                  ?.payment_status
                              : "unpaid"
                            /* item.job_details.map((payment) => (payment.payment_information.payment_status))*/
                          }
                        </td>

                        <td>{moment(date).format("DD-MM-YYYY")}</td>

                        <td>
                          {/* <MdEdit
                                                        className="pointer"
                                                        onClick={() => history.push(`edit-tracking?id=${item.job_token}`)}
                                                        color="#0323fe"
                                                        size="25px"
                                                    /> */}

                          {/* <Link to={{
                                                        pathname: `/telr-payment-details`,
                                                        state: item
                                                    }}> */}
                          <MdVisibility
                            className="pointer"
                            onClick={() =>
                              history.push(
                                `/telr-payment-details?id=${item._id}`,
                                item
                              )
                            }
                            color="#0323fe"
                            size="25px"
                          />
                          {/* </Link> */}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {dataList && dataList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {dataList &&
                dataList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}

              <Loader isShow={loader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
